/* tslint:disable */
import {
  Entity,
  Apptype,
  Tenant,
  App
} from '../index';

declare var Object: any;
export interface EntityfieldInterface {
  fieldtype: string;
  name: string;
  status: string;
  label: string;
  description: string;
  helptext?: string;
  displayformat?: string;
  sortorder: number;
  startingnumber?: number;
  checkboxdefault?: string;
  dateformat?: string;
  length?: number;
  decimalplaces?: number;
  required: boolean;
  cascaded: boolean;
  readonly: boolean;
  defaultvalue?: string;
  unique?: boolean;
  casesensitivity?: boolean;
  externaluniqueid: boolean;
  lookupfield?: string;
  lookupfieldtype?: string;
  picklistfieldtype?: string;
  picklistvaluetype?: string;
  picklistglobalvalues?: string;
  picklistcustomvalues?: Array<any>;
  hideexpression?: string;
  expressionproperties?: string;
  lifecycle?: string;
  validationpattern?: string;
  sortalphabetically?: boolean;
  lastupdatedby?: string;
  createdby?: string;
  id?: any;
  entityId?: any;
  apptypeId?: any;
  tenantId?: any;
  appId?: any;
  createdAt: Date;
  updatedAt: Date;
  entity?: Entity;
  apptype?: Apptype;
  tenant?: Tenant;
  app?: App;
}

export class Entityfield implements EntityfieldInterface {
  fieldtype: string;
  name: string;
  status: string;
  label: string;
  description: string;
  helptext: string;
  displayformat: string;
  sortorder: number;
  startingnumber: number;
  checkboxdefault: string;
  dateformat: string;
  length: number;
  decimalplaces: number;
  required: boolean;
  cascaded: boolean;
  readonly: boolean;
  defaultvalue: string;
  unique: boolean;
  casesensitivity: boolean;
  externaluniqueid: boolean;
  lookupfield: string;
  lookupfieldtype: string;
  picklistfieldtype: string;
  picklistvaluetype: string;
  picklistglobalvalues: string;
  picklistcustomvalues: Array<any>;
  hideexpression: string;
  expressionproperties: string;
  lifecycle: string;
  validationpattern: string;
  sortalphabetically: boolean;
  lastupdatedby: string;
  createdby: string;
  id: any;
  entityId: any;
  apptypeId: any;
  tenantId: any;
  appId: any;
  createdAt: Date;
  updatedAt: Date;
  entity: Entity;
  apptype: Apptype;
  tenant: Tenant;
  app: App;
  constructor(data?: EntityfieldInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Entityfield`.
   */
  public static getModelName() {
    return "Entityfield";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Entityfield for dynamic purposes.
  **/
  public static factory(data: EntityfieldInterface): Entityfield{
    return new Entityfield(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Entityfield',
      plural: 'entityfields',
      properties: {
        fieldtype: {
          name: 'fieldtype',
          type: 'string'
        },
        name: {
          name: 'name',
          type: 'string'
        },
        status: {
          name: 'status',
          type: 'string'
        },
        label: {
          name: 'label',
          type: 'string'
        },
        description: {
          name: 'description',
          type: 'string'
        },
        helptext: {
          name: 'helptext',
          type: 'string'
        },
        displayformat: {
          name: 'displayformat',
          type: 'string'
        },
        sortorder: {
          name: 'sortorder',
          type: 'number'
        },
        startingnumber: {
          name: 'startingnumber',
          type: 'number'
        },
        checkboxdefault: {
          name: 'checkboxdefault',
          type: 'string'
        },
        dateformat: {
          name: 'dateformat',
          type: 'string'
        },
        length: {
          name: 'length',
          type: 'number'
        },
        decimalplaces: {
          name: 'decimalplaces',
          type: 'number'
        },
        required: {
          name: 'required',
          type: 'boolean',
          default: false
        },
        cascaded: {
          name: 'cascaded',
          type: 'boolean',
          default: false
        },
        readonly: {
          name: 'readonly',
          type: 'boolean',
          default: false
        },
        defaultvalue: {
          name: 'defaultvalue',
          type: 'string'
        },
        unique: {
          name: 'unique',
          type: 'boolean',
          default: false
        },
        casesensitivity: {
          name: 'casesensitivity',
          type: 'boolean',
          default: false
        },
        externaluniqueid: {
          name: 'externaluniqueid',
          type: 'boolean',
          default: false
        },
        lookupfield: {
          name: 'lookupfield',
          type: 'string'
        },
        lookupfieldtype: {
          name: 'lookupfieldtype',
          type: 'string'
        },
        picklistfieldtype: {
          name: 'picklistfieldtype',
          type: 'string'
        },
        picklistvaluetype: {
          name: 'picklistvaluetype',
          type: 'string'
        },
        picklistglobalvalues: {
          name: 'picklistglobalvalues',
          type: 'string'
        },
        picklistcustomvalues: {
          name: 'picklistcustomvalues',
          type: 'Array&lt;any&gt;'
        },
        hideexpression: {
          name: 'hideexpression',
          type: 'string'
        },
        expressionproperties: {
          name: 'expressionproperties',
          type: 'string'
        },
        lifecycle: {
          name: 'lifecycle',
          type: 'string'
        },
        validationpattern: {
          name: 'validationpattern',
          type: 'string'
        },
        sortalphabetically: {
          name: 'sortalphabetically',
          type: 'boolean',
          default: false
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        entityId: {
          name: 'entityId',
          type: 'any'
        },
        apptypeId: {
          name: 'apptypeId',
          type: 'any'
        },
        tenantId: {
          name: 'tenantId',
          type: 'any'
        },
        appId: {
          name: 'appId',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        entity: {
          name: 'entity',
          type: 'Entity',
          model: 'Entity'
        },
        apptype: {
          name: 'apptype',
          type: 'Apptype',
          model: 'Apptype'
        },
        tenant: {
          name: 'tenant',
          type: 'Tenant',
          model: 'Tenant'
        },
        app: {
          name: 'app',
          type: 'App',
          model: 'App'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Entityfield.ts